/******/
(() => {
  // webpackBootstrap
  /* eslint-disable */

  if (!customElements.get('variant-dropdown')) {
    customElements.define(
      'variant-dropdown',
      class VariantDropdown extends HTMLElement {
        constructor() {
          super();

          /* ===== Bind event handlers ===== */
          [
            'onDocumentClick',
            'handleOptionKeyDown',
            'closeDropdownOnFocusOut'
          ].forEach((fn) => {
            this[fn] = this[fn].bind(this);
          });
        }

        connectedCallback() {
          /* ===== Cache DOM elements and attach event listeners ===== */
          this.cacheDOMElements();
          this.addEventListeners();
        }

        cacheDOMElements() {
          this.dropdownButton = this.querySelector('[data-dropdown-button]');
          this.dropdownList = this.querySelector('[data-dropdown-list]');
          this.selectedOptionDisplay = this.querySelector('[data-selected-option]');
          this.options = this.dropdownList.querySelectorAll('li');
          this.productForm = this.closest('product-information');
          this.sectionId = this.getAttribute('data-section-id');

          /* ===== Make sure dropdown starts in the correct closed state ===== */
          this.dropdownButton.setAttribute('aria-expanded', 'false');
        }

        addEventListeners() {
          /* ===== Attach event listeners ===== */
          this.dropdownButton.addEventListener('click', () => {
            this.toggleDropdown();
          });

          this.options.forEach((option) => {
            option.addEventListener('click', () => {
              this.handleOptionClick(option);
            });

            option.addEventListener('keydown', this.handleOptionKeyDown);
          });

          this.dropdownList.addEventListener(
            'focusout',
            this.closeDropdownOnFocusOut
          );

          document.addEventListener('click', this.onDocumentClick);
        }

        handleOptionKeyDown(event) {
          /* ===== Select an option with Enter ===== */
          if (event.key === 'Enter') {
            this.handleOptionClick(event.currentTarget);
          }
        }

        closeDropdownOnFocusOut() {
          /* ===== Close when focus leaves the dropdown ===== */
          setTimeout(() => {
            if (!this.contains(document.activeElement)) {
              this.dropdownButton.setAttribute('aria-expanded', 'false');
              this.updateDropdownClasses(true);
              this.closeDropdown();
            }
          }, 0);
        }

        handleOptionClick(option) {
          /* ===== Handle option selection ===== */
          this.updateOptionLabel(this.selectedOptionDisplay, option);
          this.markOptionAsSelected(option);

          this.dropdownButton.setAttribute('aria-expanded', 'false');
          this.updateDropdownClasses(true);
          this.closeDropdown();

          this.onOptionChange(option);
        }

        toggleDropdown() {
          /* ===== Toggle dropdown open and closed ===== */
          const isOpen = this.dropdownList.style.display === 'block';

          if (isOpen) {
            /* ===== Close dropdown ===== */
            this.dropdownButton.setAttribute('aria-expanded', 'false');
            this.updateDropdownClasses(true);
            this.closeDropdown();
            this.dropdownButton.focus();
          } else {
            /* ===== Open dropdown ===== */
            this.dropdownList.style.display = 'block';
            this.dropdownButton.setAttribute('aria-expanded', 'true');

            setTimeout(() => {
              this.updateDropdownClasses(false);
            }, 50);
          }
        }

        onOptionChange(option) {
          const dropdownId = option.getAttribute('data-dropdown-id');
          const productUrl = option.getAttribute('data-product-url');
          const productFetchUrl = option.getAttribute('data-product-fetch-url');
          const currentVariant = this.getVariantData(dropdownId);
          const isCombinedListing =
            option.getAttribute('data-is-combined-listing') === 'true';

          this.emitVariantChangeEvent(
            currentVariant,
            productFetchUrl,
            productUrl,
            isCombinedListing
          );
        }

        emitVariantChangeEvent(
          variant,
          productFetchUrl,
          productUrl,
          isCombinedListing = false
        ) {
          /* ===== Emit the variant:change event ===== */
          eventBus.emit('variant:change', {
            sectionId: this.sectionId,
            variant: variant,
            fetchURL: productFetchUrl,
            productURL: productUrl,
            isCombinedListing: isCombinedListing
          });
        }

        updateOptionLabel(currentLabelElement, newLabelElement) {
          /* ===== Update selected option text ===== */
          const newLabel =
            newLabelElement.querySelector('.option-label').textContent;

          currentLabelElement.textContent = newLabel;
        }

        updateDropdownClasses(isOpen) {
          /* ===== Update dropdown animation classes ===== */
          const action = isOpen ? 'remove' : 'add';

          this.classList[action]('variant-dropdown--open');

          this.dropdownList.classList[action](
            'variant-dropdown-fade-enter-active',
            'variant-dropdown-fade-enter-to',
            'variant-dropdown-fade-enter'
          );

          this.dropdownList.classList[
            action === 'add' ? 'remove' : 'add'
          ](
            'variant-dropdown-fade-leave-active',
            'variant-dropdown-fade-leave-to',
            'variant-dropdown-fade-enter'
          );
        }

        markOptionAsSelected(option) {
          /* ===== Update selected option state ===== */
          this.options.forEach((opt) => {
            opt.removeAttribute('selected');
            opt.classList.remove('selected');
          });

          option.setAttribute('selected', '');
          option.classList.add('selected');
        }

        onDocumentClick(event) {
          /* ===== Close when clicking outside ===== */
          if (!this.contains(event.target)) {
            this.dropdownButton.setAttribute('aria-expanded', 'false');
            this.updateDropdownClasses(true);
            this.closeDropdown();
          }
        }

        closeDropdown() {
          /* ===== Hide dropdown after close animation ===== */
          setTimeout(() => {
            this.dropdownList.style.display = 'none';
          }, 150);
        }

        getVariantData(dropdownId) {
          return JSON.parse(
            this.getVariantDataElement(dropdownId).textContent
          );
        }

        getVariantDataElement(dropdownId) {
          return this.querySelector(
            `script[type="application/json"][data-resource="${dropdownId}"]`
          );
        }

        disconnectedCallback() {
          /* ===== Remove event listeners ===== */
          this.dropdownList.removeEventListener(
            'focusout',
            this.closeDropdownOnFocusOut
          );

          document.removeEventListener('click', this.onDocumentClick);
        }
      }
    );
  }
})();
/******/